// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kn-search__search___3Zpb2 {
  background-color: #eaeaea !important;
}

.inputBoxUpload-wrapper {
  min-height: 50px;
}

.secondary-body-min-height {
  min-height: 20vh;
}

.selectedFile {
  display: flex;
  justify-content: space-between;
  padding: 0px 15px 15px 0px;
  width: 65%;
}

.file-details {
  width: 85%;
  word-break: break-all;
  font-size: 12px;
}

.file-details p {
  color: "#e30613";
  margin-bottom: 0px;
}

.file-details .date {
  font-size: 10px;
}

.delete-file {
  color: "#e30613";
  font-size: 16px;
}
.delete-file:hover {
  cursor: pointer;
}

.draggable {
  text-align: center;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 50%;
}

.drag-text {
  color: #cac5c5;
  font-size: 12px;
  margin: 10px 0px !important;
}

.draggable:focus {
  outline: none;
}
.draggable:hover {
  cursor: pointer;
}

.fa-cloud-upload-alt {
  font-size: 16px;
  color: #d5d5d4;
  padding-right: 10px;
}

.switch-wrapper > input[type="checkbox"] {
  opacity: 0;
  position: absolute;
}

.switch-wrapper > input[type="checkbox"] + .switch {
  transform: translateX(5px);
}
.switch-wrapper > input[type="checkbox"]:checked + .switch {
  transform: translateX(50%) translateX(-19px);
}
.switch-wrapper.large > input[type="checkbox"]:checked + .switch {
  transform: translateX(50%) translateX(-35px);
}
.switch-wrapper > input[type="checkbox"]:disabled + .switch {
  background: #ccc;
}

.switch-wrapper {
  border-radius: 20px;
  cursor: pointer;
  height: 24px;
  float: left;
  overflow: hidden;
  position: relative;
  width: 48px;
}
.switch-wrapper.large {
  height: 40px;
  width: 80px;
}
.switch-wrapper > .switch {
  color: #fff;
  display: inline-block;
  height: 100%;
  left: -100%;
  position: relative;
  transition: 100ms linear;
  width: 200%;
}
.switch-wrapper > .switch > .switch-handle {
  background: #fff;
  border-radius: 50%;
  display: inline-block;
  height: 14px;
  left: 50%;
  position: relative;
  top: 3px;
  width: 14px;
  z-index: 3;
}
.switch-wrapper.large > .switch > .switch-handle {
  height: 30px;
  width: 30px;
}
.switch-label {
  float: left;
  margin-left: 10px;
}
.switch-wrapper.large + .switch-label {
  line-height: 4rem;
  margin-left: 15px;
}

.no-effects,
.no-effects:active,
.no-effects:focus {
  box-shadow: none !important;
  background: transparent !important;
  padding: 0px;
}

.no-transform {
  transform: none !important;
}

.border-none {
  border: none !important;
}

.block-wrapper {
  border-radius: 0.375rem;
  box-shadow:
    0 1px 3px rgb(50 50 93 / 15%),
    0 1px 0 rgb(0 0 0 / 2%);
  padding: 20px;
  margin-bottom: 20px;
}

.table-responsive {
  min-height: 150px;
}

.blue-text {
  color: blue;
}
iframe {
  display: none !important;
}

.css-1s2u09g-control,
.css-1s2u09g-control:active,
.css-1s2u09g-control:hover,
.css-1s2u09g-control:focus,
.css-1pahdxg-control:hover,
.css-1pahdxg-control {
  border-radius: 0.375rem !important;
  border: none !important;
  outline: none !important;
  font-size: 0.875rem !important;
  min-height: calc(1.5em + 1.25rem + 2px) !important;
  box-shadow:
    0 1px 3px rgb(50 50 93 / 15%),
    0 1px 0 rgb(0 0 0 / 2%) !important;
}
.css-1okebmr-indicatorSeparator {
  display: none !important;
}
.css-tj5bde-Svg {
  color: #8898aa !important;
  height: 17px !important;
}
.css-26l3qy-menu * {
  background-color: transparent;
}
.css-26l3qy-menu .active,
.css-26l3qy-menu .selected {
  background-color: red;
}

.removePic {
  z-index: 1;
}
.file-input input {
  opacity: 0;
  position: absolute;
  left: 0px;
  height: 64px;
  max-width: 100%;
  cursor: pointer;
}
.profile-img {
  height: 85px;
  width: 85px;
  border-radius: 50%;
}
.ctaRow {
  align-items: center;
  color: #122132;
  display: flex;
  font-family: SF Pro Display Bold;
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 16px;
  justify-content: space-between;
  height: 100%;
}
.ctaRow img {
  margin-right: 16px;
}
.ctaRow .removePic {
  position: absolute;
  left: 75px;
  top: -1px;
  height: 25px;
  width: 25px;
}
.move-left {
  left: 202px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE,2BAA2B;EAC3B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB;;2BAEyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kDAAkD;EAClD;;sCAEoC;AACtC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".kn-search__search___3Zpb2 {\n  background-color: #eaeaea !important;\n}\n\n.inputBoxUpload-wrapper {\n  min-height: 50px;\n}\n\n.secondary-body-min-height {\n  min-height: 20vh;\n}\n\n.selectedFile {\n  display: flex;\n  justify-content: space-between;\n  padding: 0px 15px 15px 0px;\n  width: 65%;\n}\n\n.file-details {\n  width: 85%;\n  word-break: break-all;\n  font-size: 12px;\n}\n\n.file-details p {\n  color: \"#e30613\";\n  margin-bottom: 0px;\n}\n\n.file-details .date {\n  font-size: 10px;\n}\n\n.delete-file {\n  color: \"#e30613\";\n  font-size: 16px;\n}\n.delete-file:hover {\n  cursor: pointer;\n}\n\n.draggable {\n  text-align: center;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  width: 50%;\n}\n\n.drag-text {\n  color: #cac5c5;\n  font-size: 12px;\n  margin: 10px 0px !important;\n}\n\n.draggable:focus {\n  outline: none;\n}\n.draggable:hover {\n  cursor: pointer;\n}\n\n.fa-cloud-upload-alt {\n  font-size: 16px;\n  color: #d5d5d4;\n  padding-right: 10px;\n}\n\n.switch-wrapper > input[type=\"checkbox\"] {\n  opacity: 0;\n  position: absolute;\n}\n\n.switch-wrapper > input[type=\"checkbox\"] + .switch {\n  transform: translateX(5px);\n}\n.switch-wrapper > input[type=\"checkbox\"]:checked + .switch {\n  transform: translateX(50%) translateX(-19px);\n}\n.switch-wrapper.large > input[type=\"checkbox\"]:checked + .switch {\n  transform: translateX(50%) translateX(-35px);\n}\n.switch-wrapper > input[type=\"checkbox\"]:disabled + .switch {\n  background: #ccc;\n}\n\n.switch-wrapper {\n  border-radius: 20px;\n  cursor: pointer;\n  height: 24px;\n  float: left;\n  overflow: hidden;\n  position: relative;\n  width: 48px;\n}\n.switch-wrapper.large {\n  height: 40px;\n  width: 80px;\n}\n.switch-wrapper > .switch {\n  color: #fff;\n  display: inline-block;\n  height: 100%;\n  left: -100%;\n  position: relative;\n  transition: 100ms linear;\n  width: 200%;\n}\n.switch-wrapper > .switch > .switch-handle {\n  background: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  height: 14px;\n  left: 50%;\n  position: relative;\n  top: 3px;\n  width: 14px;\n  z-index: 3;\n}\n.switch-wrapper.large > .switch > .switch-handle {\n  height: 30px;\n  width: 30px;\n}\n.switch-label {\n  float: left;\n  margin-left: 10px;\n}\n.switch-wrapper.large + .switch-label {\n  line-height: 4rem;\n  margin-left: 15px;\n}\n\n.no-effects,\n.no-effects:active,\n.no-effects:focus {\n  box-shadow: none !important;\n  background: transparent !important;\n  padding: 0px;\n}\n\n.no-transform {\n  transform: none !important;\n}\n\n.border-none {\n  border: none !important;\n}\n\n.block-wrapper {\n  border-radius: 0.375rem;\n  box-shadow:\n    0 1px 3px rgb(50 50 93 / 15%),\n    0 1px 0 rgb(0 0 0 / 2%);\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.table-responsive {\n  min-height: 150px;\n}\n\n.blue-text {\n  color: blue;\n}\niframe {\n  display: none !important;\n}\n\n.css-1s2u09g-control,\n.css-1s2u09g-control:active,\n.css-1s2u09g-control:hover,\n.css-1s2u09g-control:focus,\n.css-1pahdxg-control:hover,\n.css-1pahdxg-control {\n  border-radius: 0.375rem !important;\n  border: none !important;\n  outline: none !important;\n  font-size: 0.875rem !important;\n  min-height: calc(1.5em + 1.25rem + 2px) !important;\n  box-shadow:\n    0 1px 3px rgb(50 50 93 / 15%),\n    0 1px 0 rgb(0 0 0 / 2%) !important;\n}\n.css-1okebmr-indicatorSeparator {\n  display: none !important;\n}\n.css-tj5bde-Svg {\n  color: #8898aa !important;\n  height: 17px !important;\n}\n.css-26l3qy-menu * {\n  background-color: transparent;\n}\n.css-26l3qy-menu .active,\n.css-26l3qy-menu .selected {\n  background-color: red;\n}\n\n.removePic {\n  z-index: 1;\n}\n.file-input input {\n  opacity: 0;\n  position: absolute;\n  left: 0px;\n  height: 64px;\n  max-width: 100%;\n  cursor: pointer;\n}\n.profile-img {\n  height: 85px;\n  width: 85px;\n  border-radius: 50%;\n}\n.ctaRow {\n  align-items: center;\n  color: #122132;\n  display: flex;\n  font-family: SF Pro Display Bold;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  line-height: 16px;\n  justify-content: space-between;\n  height: 100%;\n}\n.ctaRow img {\n  margin-right: 16px;\n}\n.ctaRow .removePic {\n  position: absolute;\n  left: 75px;\n  top: -1px;\n  height: 25px;\n  width: 25px;\n}\n.move-left {\n  left: 202px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
